const voicesData = {
    Azure: {
        English: [
            {
                name: "Jane",
                value: "en-US-JaneNeural",
                audioSrc: "https://ai.azure.com/speechassetscache/ttsvoice/Masterpieces/En-US-Jane-General-Audio.wav"
            },
            {
                name: "Davis",
                value: "en-US-DavisNeural",
                audioSrc: "https://ai.azure.com/speechassetscache/ttsvoice/Masterpieces/En-US-Davis-General-Audio.wav"
            },
            {
                name: "Jason",
                value: "en-US-JasonNeural",
                audioSrc: "https://ai.azure.com/speechassetscache/ttsvoice/Masterpieces/En-US-Jason-General-Audio.wav"
            },
            {
                name: "Nancy",
                value: "en-US-NancyNeural",
                audioSrc: "https://ai.azure.com/speechassetscache/ttsvoice/Masterpieces/En-US-Nancy-General-Audio.wav"
            },
            {
                name: "Tony",
                value: "en-US-TonyNeural",
                audioSrc: "https://ai.azure.com/speechassetscache/ttsvoice/Masterpieces/En-US-Tony-General-Audio.wav"
            },
        ],
        
        Polish: [
            {
                name: "Agnieszka",
                value: "pl-PL-AgnieszkaNeural",
                audioSrc: "https://ai.azure.com/speechassetscache/ttsvoice/Masterpieces/pl-PL-Agnieszka-General-Audio.wav"
            },
            {
                name: "Marek",
                value: "pl-PL-MarekNeural",
                audioSrc: "https://ai.azure.com/speechassetscache/ttsvoice/Masterpieces/pl-PL-Marek-General-Audio.wav"
            },
            {
                name: "Zofia",
                value: "pl-PL-ZofiaNeural",
                audioSrc: "https://ai.azure.com/speechassetscache/ttsvoice/Masterpieces/pl-PL-Zofia-General-Audio.wav"
            }
    ],
        Multilingual: [
        {
            name: "Xiao",
            value: "zh-CN-XiaochenMultilingualNeural",
            audioSrc: "https://ai.azure.com/speechassetscache/ttsvoice/Masterpieces/zh-CN-XiaochenMultilingual-General-Audio.wav"
        },
        {
            name: "Onyx",
            value: "en-US-OnyxTurboMultilingualNeural",
            audioSrc: "https://staticassets.api.speech.microsoft.com/blobs/ttsvoice/Masterpieces/en-US-OnyxTurboMultilingual-General-Audio.wav"
        },
        {
            name: "Ash",
            value: "en-US-AshTurboMultilingualNeural",
            audioSrc: "https://staticassets.api.speech.microsoft.com/blobs/ttsvoice/Masterpieces/en-US-AshTurboMultilingual-General-Audio.wav"
        },
        {
            name: "Shimmer",
            value: "en-US-ShimmerTurboMultilingualNeural",
            audioSrc: "https://staticassets.api.speech.microsoft.com/blobs/ttsvoice/Masterpieces/en-US-ShimmerTurboMultilingual-General-Audio.wav"
        },
        {
            name: "Echo",
            value: "en-US-EchoMultilingualNeural",
            audioSrc: "https://staticassets.api.speech.microsoft.com/blobs/ttsvoice/Masterpieces/en-US-EchoTurboMultilingual-General-Audio.wav"
        },
        {
            name: "Fable",
            value: "en-US-FableTurboMultilingualNeural",
            audioSrc: "https://staticassets.api.speech.microsoft.com/blobs/ttsvoice/Masterpieces/en-US-FableTurboMultilingual-General-Audio.wav"
        },
        {
            name: "Andrew3",
            value: "en-US-Andrew3:DragonHDLatestNeural",
            audioSrc: "https://staticassets.api.speech.microsoft.com/blobs/ttsvoice/Masterpieces/en-US-Andrew3DragonHDLatest-General-Audio.wav"
        },
        {
            name: "Alloy",
            value: "en-US-AlloyTurboMultilingualNeural",
            audioSrc: "https://staticassets.api.speech.microsoft.com/blobs/ttsvoice/Masterpieces/en-US-AlloyTurboMultilingual-General-Audio.wav"
        }
            
    ]
    },
    Deepgram: {
        English: [
            {
                name: "Asteria",
                value: "asteria",
                audioSrc: "https://res.cloudinary.com/deepgram/video/upload/v1709565353/aura/asteria_docs_venw0r.wav"
            },
            {
                name: "Luna",
                value: "luna",
                audioSrc: "https://res.cloudinary.com/deepgram/video/upload/v1709565351/aura/luna_docs_clom0e.wav"
            },
            {
                name: "Stella",
                value: "stella",
                audioSrc: "https://res.cloudinary.com/deepgram/video/upload/v1709565349/aura/stella_docs_xh5jbv.wav"
            },
            {
                name: "Athena",
                value: "athena",
                audioSrc: "https://res.cloudinary.com/deepgram/video/upload/v1709565613/aura/athena_docs_wyznud.wav"
            },
            {
                name: "Hera",
                value: "hera",
                audioSrc: "https://res.cloudinary.com/deepgram/video/upload/v1709565347/aura/hera_docs_xjkt4x.wav"
            },
            {
                name: "Orion",
                value: "orion",
                audioSrc: "https://res.cloudinary.com/deepgram/video/upload/v1709565346/aura/orion_docs_aljv1q.mp3"
            },
            {
                name: "Arcas",
                value: "arcas",
                audioSrc: "https://res.cloudinary.com/deepgram/video/upload/v1709565348/aura/arcas_docs_pc9hxp.mp3"
            },
            {
                name: "Perseus",
                value: "perseus",
                audioSrc: "https://res.cloudinary.com/deepgram/video/upload/v1709565350/aura/perseus_docs_ap7fc0.wav"
            },
            {
                name: "Angus",
                value: "angus",
                audioSrc: "https://res.cloudinary.com/deepgram/video/upload/v1709565352/aura/angus_docs_lgse2b.wav"
            },
            {
                name: "Orpheus",
                value: "orpheus",
                audioSrc: "https://res.cloudinary.com/deepgram/video/upload/v1709565350/aura/orpheus_docs_zdlpcf.wav"
            },
            {
                name: "Helios",
                value: "helios",
                audioSrc: "https://res.cloudinary.com/deepgram/video/upload/v1709565346/aura/helios_docs_ycjwoo.wav"
            },
            {
                name: "Zeus",
                value: "zeus",
                audioSrc: "https://res.cloudinary.com/deepgram/video/upload/v1709565347/aura/zeus_docs_fupdiv.wav"
            }
        ]

       
    },
    //"Realtime Api": {
    //    Multilingual: [
    //        { name: "Alloy", value: "alloy", audioSrc: "https://cdn.openai.com/API/docs/audio/alloy.wav" },
    //        { name: "Ash", value: "ash", audioSrc: "https://cdn.openai.com/API/docs/audio/ash.wav" },
    //        { name: "Coral", value: "coral", audioSrc: "https://cdn.openai.com/API/docs/audio/coral.wav" },
    //        { name: "Echo", value: "echo", audioSrc: "https://cdn.openai.com/API/docs/audio/echo.wav" },
    //        { name: "Ballad", value: "ballad", audioSrc: "https://cdn.openai.com/API/docs/audio/ballad.wav" },
    //        { name: "Verse", value: "verse", audioSrc: "https://cdn.openai.com/API/docs/audio/verse.wav" },
    //        { name: "Sage", value: "sage", audioSrc: "https://cdn.openai.com/API/docs/audio/sage.wav" },
    //        { name: "Shimmer", value: "shimmer", audioSrc: "https://cdn.openai.com/API/docs/audio/shimmer.wav" },

    //    ],
    //},
    "OpenAi": {
        Multilingual: [
        { name: "Alloy", value: "alloy", audioSrc: "https://cdn.openai.com/API/docs/audio/alloy.wav" },
        { name: "Ash", value: "ash", audioSrc: "https://cdn.openai.com/API/docs/audio/ash.wav" },
        { name: "Ballad", value: "ballad", audioSrc: "https://cdn.openai.com/API/docs/audio/ballad.wav" },
        { name: "Coral", value: "coral", audioSrc: "https://cdn.openai.com/API/docs/audio/coral.wav" },
        { name: "Echo", value: "echo", audioSrc: "https://cdn.openai.com/API/docs/audio/echo.wav" },
        { name: "Fable", value: "fable", audioSrc: "https://cdn.openai.com/API/docs/audio/fable.wav" },
        { name: "Sage", value: "sage", audioSrc: "https://cdn.openai.com/API/docs/audio/sage.wav" },
        { name: "Shimmer", value: "shimmer", audioSrc: "https://cdn.openai.com/API/docs/audio/shimmer.wav" },
        { name: "Verse", value: "verse", audioSrc: "https://cdn.openai.com/API/docs/audio/verse.wav" },
        { name: "Sol", value: "sol", audioSrc: "https://cdn.openai.com/API/docs/audio/sol.wav" },
        { name: "Breeze", value: "breeze", audioSrc: "https://cdn.openai.com/API/docs/audio/breeze.wav" },
    ],
    },
    "ElevenLabs": {}
};

export default voicesData;
